const ALPHABET = 'M9S3Q7W4HCZ8D6XFNJVK2LGP5RTYB1'
const NUMBER_BASE = ALPHABET.length
const DEFAULT_DESIRED_ENCODING_LENGTH = 7
const PERSON_ID_REGEX = /^[a-zA-Z0-9]{4}-[a-zA-Z0-9]{3}$/
const CIS_ID_REGEX = /^[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/
const TREE_ID_REGEX = /^[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/
const OWS_ID_REGEX = /^([a-zA-Z0-9]{4}-[a-zA-Z0-9]{3,4})$|^([0-9]+)$/
const MRN_REGEX = /^([a-zA-Z0-9]{3}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}|[a-zA-Z0-9]{13})$/

function insertSeparator(value) {
  return value.replace(/(\w{4})(\w*)/, '$1-$2')
}

function removePrefix(id) {
  const idIndex = id.indexOf('.')
  if (idIndex !== -1) {
    return id.substring(idIndex + 1)
  }
  return id
}

function encode(value, desiredEncodedIdLength) {
  if (!desiredEncodedIdLength) {
    desiredEncodedIdLength = DEFAULT_DESIRED_ENCODING_LENGTH
  }
  value = parseInt(value, 10)

  function padWithZero(encodedValue) {
    if (typeof desiredEncodedIdLength !== 'number') {
      desiredEncodedIdLength = DEFAULT_DESIRED_ENCODING_LENGTH
    }
    const padSize = desiredEncodedIdLength - encodedValue.length
    if (padSize > 0) {
      return 'MMMMMMM'.substr(0, padSize) + encodedValue
    }
    return encodedValue
  }

  function encodeValue(encodedValue) {
    const result = []
    while (encodedValue > 0) {
      result.push(ALPHABET.charAt(encodedValue % NUMBER_BASE))
      encodedValue = Math.floor(encodedValue / NUMBER_BASE)
    }
    return result.reverse().join('')
  }

  return insertSeparator(padWithZero(encodeValue(value)))
}

function decode(id) {
  const idArray = id.replace('-', '').toUpperCase().split('')
  let result = 0
  let isEncodingNotValid = false
  idArray.forEach((idChar) => {
    const idIndex = ALPHABET.indexOf(idChar)
    if (idIndex === -1) {
      isEncodingNotValid = true
    } else {
      result = result * NUMBER_BASE + idIndex
    }
  })
  return isEncodingNotValid ? 0 : result
}

export function getEntity(id, desiredEncodedIdLength) {
  const IS_PURE_NUMBER = /^\d+$/
  const IS_PURE_ALPHA = /^[A-Za-z]+$/
  const entity = {
    numericId: 0,
    alphaNumericId: '',
  }

  if (id) {
    id = removePrefix(id.trim())
    if (IS_PURE_NUMBER.test(id)) {
      entity.alphaNumericId = encode(id, desiredEncodedIdLength)
      entity.numericId = parseInt(id, 10)
    } else if (IS_PURE_ALPHA.test(id) && id.length === 5) {
      // Used to correctly parse temple code, ex: t.BOISE
      entity.alphaNumericId = id.toUpperCase()
    } else {
      // If it needs a separator, insert one here
      id = id.indexOf('-') === -1 ? insertSeparator(id) : id
      entity.alphaNumericId = id.toUpperCase()
      entity.numericId = decode(id)
      if (entity.numericId === 0) {
        entity.alphaNumericId = ''
      }
    }
  }
  return entity
}

export function mrnRemoveDashes(input) {
  if (input && input.indexOf('-') !== -1) {
    input = input.replace('-', '00')
    input = input.replace(/-/, '')
  }
  return input
}

export const isAlphaNumericPersonId = (personId) => {
  return PERSON_ID_REGEX.test(personId)
}

export const isAlphaNumericCisId = (cisId) => {
  return CIS_ID_REGEX.test(cisId)
}

export const isAlphaNumericTreeId = (cisId) => {
  return TREE_ID_REGEX.test(cisId)
}

export const isMrn = (mrn) => {
  return MRN_REGEX.test(mrn)
}

export const isOwsId = (owsId) => {
  return OWS_ID_REGEX.test(owsId)
}

export function isWKC(contributorId) {
  if (contributorId && typeof contributorId !== 'number' && contributorId.toLowerCase().includes('wkc')) {
    return true
  }

  const contributorEntity = getEntity(contributorId)
  const extraWKCList = [
    1000, 1005, 1008, 1015, 1021, 1000001, 1179018, 5470317, 42529428, 730004520, 733513527, 735414007, 785590614,
    800743003, 3000000501,
  ]
  const numericId = contributorEntity.numericId
  return numericId <= 30 || extraWKCList.includes(numericId)
}
